<template>
    <div class="device-type-manange relative">
        <!-- 表单开始 -->
<!--        <div class="buttons">-->
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
<!--        </div>-->
<!--        <el-row class="inputs mg-20" :gutter="20">-->
<!--            <el-col :md="6" :lg="6" :xl="4">-->
<!--                <span class="fs-14 pd-r-10">标题：</span>-->
<!--                <el-input v-model="title" placeholder="标题模糊搜索"/>-->
<!--            </el-col>-->
<!--        </el-row>-->
        <!-- 表单结束 -->
        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column width="120" prop="id" label="ID" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="article_title" label="文章标题" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="article_type" label="文章所属" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="update_date" label="更新日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">编辑
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                title: ""
            };
        },
        created() {

        },
        mounted() {
            // 获取文章列表
            this.getList();
            localStorage.setItem('prev_page', 'article_list')
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'articleList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        title: this.title
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '启用';
                                res.data.data.list[i].status_number = 1;
                                break;
                            case '2':
                                res.data.data.list[i].status = '停用';
                                res.data.data.list[i].status_number = 2;
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "articleEdit", params: {
                        id: data.id,
                    }
                });
            },

            // 重置按钮
            resetForm() {
                this.title = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
